import React, { useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { CardsWidget20, CardsWidget7 } from '../../../_metronic/partials/widgets';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { ApexChartBar } from '../../Components/Charts/apexBarChart';
import { ApexChartPie } from '../../Components/Charts/apexPieChart';
import { ApexChartDonut } from '../../Components/Charts/apexDonutChart';
import MexicoMap from '../../Components/Mapa/mapa';

const API_URL = process.env.REACT_APP_API_URL
type dataType = {
  porcentaje: string,
  actual: number,
  total: number,
  diff: number
}
const DashboardWrapper: React.FC = () => {
  const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);

  const [data, setData] = useState<dataType>({
    porcentaje: '',
    actual: 0,
    total: 0,
    diff: 0
  })

  const [dataWhisper, setDataWhisper] = useState<dataType>({
    porcentaje: '',
    actual: 0,
    total: 0,
    diff: 0
  })

  const [barData, setBarData] = useState<any[]>([])
  const [pieData, setPieData] = useState<any[]>([{ series: [0], labels: [""] }])
  const [donutData, setDonutData] = useState<any[]>([{ series: [0], labels: [""] }])
  const [sexoData, setSexoData] = useState<any[]>([{ series: [0], labels: [""] }])
  const [violacionesData, setViolacionesData] = useState<any[]>([{ series: [0], labels: [""] }])
  const [tipoEntrevistaData, setTipoEntrevistaData] = useState<any[]>([{ series: [0], labels: [""] }])

  const getInfo = async () => {
    try {
      const response = await fetch(`${API_URL}/dashboard`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const entrevistas = await response.json();
      setData(entrevistas.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/transWhisper`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const entrevistas = await response.json();
      setDataWhisper(entrevistas.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/emis`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const emis = await response.json();
      setBarData(emis.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/subcontextos`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const subconts = await response.json();
      setPieData(subconts.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/tipoTestimoniante`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const subconts = await response.json();
      setDonutData(subconts.data)
      console.log(subconts)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/sexo`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const subconts = await response.json();
      setSexoData(subconts.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/gravesViolaciones`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const subconts = await response.json();
      setViolacionesData(subconts.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }

    try {
      const response = await fetch(`${API_URL}/dashboard/tipoEntrevista`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const subconts = await response.json();
      setTipoEntrevistaData(subconts.data)
      //console.log(entrevistas)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getInfo()
  }, [])

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <div className="alert alert-success d-flex align-items-center p-5 mb-10">
        <div className="d-flex flex-column">
        <span className='fs-2hx fw-bold me-2 lh-1 ls-n2'>{data.total}</span>
          <span>Número de testimonios cargados en el sistema actualmente.</span>
        </div>
      </div>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        <div className='col-md-6'>
          <ApexChartBar
            title="Entrevistas por EMI"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#FFAB40'
            chartHeight='300px'
            series={barData}
          />
        </div>
        <div className='col-md-6'>
          <ApexChartDonut
            title="Tipo de Testimoniante"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#B388FF'
            chartHeight='300px'
            series={donutData}
          />
        </div>
        <div className='col-md-6'>
          <ApexChartPie
            title="Subcontextos"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#4CAF50'
            chartHeight='500px'
            series={pieData}
          />
        </div>
        <div className='col-md-6'>
          <ApexChartDonut
            title="Graves Violaciones"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#B388FF'
            chartHeight='300px'
            series={violacionesData}
          />
        </div>
        <div className='col-md-6'>
          <ApexChartDonut
            title="Tipo de Entrevista"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#B388FF'
            chartHeight='300px'
            series={tipoEntrevistaData}
          />
        </div>
        <div className='col-md-6'>
          <ApexChartDonut
            title="Sexo"
            className='h-md-100 mb-5 mb-xl-10'
            chartColor='#B388FF'
            chartHeight='300px'
            series={sexoData}
          />
        </div>
        <div className='col-md-12'>
          <MexicoMap />
        </div>
        <div className='col-md-6'>
          <CardsWidget20
            className='h-md-100 mb-5 mb-xl-10'
            description='Entrevistas con Audios'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            data={data}
          />
        </div>
        <div className='col-md-6'>
          <CardsWidget20
            className='h-md-100 mb-5 mb-xl-10'
            description='Entrevistas con Transcripciones Whisper'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            data={dataWhisper}
          />
        </div>
      </div>
    </>
  )
}

export { DashboardWrapper };
